import Footer from "components/Footer"
import Header from "components/Header"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

function LandingpageLayout({
  navs = {},
  company = {},
  children,
  content = {},
  locations,
  socialMediaLinks,
  seo = {},
}) {
  const { asPath } = useRouter()

  const origin = process.env.NEXT_PUBLIC_ENV_HOST
    ? process.env.NEXT_PUBLIC_ENV_HOST
    : "http://localhost:3000"

  const _pathSliceLength = Math.min.apply(Math, [
    asPath.includes("?") ? asPath.indexOf("?") : asPath.length,
    asPath.includes("#") ? asPath.indexOf("#") : asPath.length,
  ])

  const canonical = `${origin}${asPath.substring(0, _pathSliceLength)}`

  const {
    title: pageTitle,
    seo_title: seoTitle,
    seo_description: seoDescription,
    seo_image: seoImage,
    seo_robots_no_index: seoNoIndex,
    seo_robots_no_follow: seoNoFollow,
  } = content

  const ogData = {
    url: canonical,
    title: seoTitle || pageTitle || company?.name || null,
    description: seoDescription || null,
    images: [],
  }

  if (seoImage?.permalink) {
    ogData.images.push({
      url: seoImage.permalink,
      width: seoImage.width,
      height: seoImage.height,
      alt: seoImage.alt,
    })
  }

  // seo properties from outside will overwrite base props
  const seoProps = {
    canonical,
    title: seoTitle || pageTitle || company?.name || null,
    description: seoDescription || null,
    noindex: seoNoIndex,
    nofollow: seoNoFollow,
    openGraph: ogData,

    ...seo,
  }

  const { footerNav, footerLinks } = navs

  return (
    <>
      <NextSeo {...seoProps} />
      <Header partner={content.partner} locale={content.locale} />
      <main className="main" id="main-content" aria-label="Inhaltsbereich">
        {children}
      </main>
      <Footer
        footerNav={footerNav}
        footerLinks={footerLinks}
        company={company}
        socialMediaLinks={socialMediaLinks}
        // no locations because this is the landingpage
      />
    </>
  )
}

export default LandingpageLayout
